import getters from './settings.getter';
import mutations from './settings.mutations';
import actions from './settings.actions';
import {
  Transaction,
  User,
  CapabilityPermission,
  RoleFormData,
  CustomPermData,
  GroupRoleFormData,
  LabelKeyType,
  UserFormData,
  RolesAndGroupRolesFieldData,
} from '@/store/modules/global/settings/settings.interfaces';
import { transactionInit } from '@/store/modules/global/settings/settings.config';
import { Duration, DurationTime } from '@/utils/types/global';
import getDurationUtc from '@/utils/time/utctime';
import getTimeZoneOff from '@/utils/time/timezone';
import getDurationRow, { getDurationLicenseRow } from '@/utils/time/datetime';
import getEnv from '@/utils/env';
import { timeLabels } from '@/components/Main/main.config';
import { KeyLabel } from '@/store/mutations-typesCommon';
import VueI18n from 'vue-i18n';
import _ from 'lodash';
import { addWidgetDefulatData } from '@/components/Settings/Custom-DB-query/settings.customQuery.types';

export interface State {
  durationRow: Duration;
  durationLicenseRow: Duration;
  durationUtc: Duration;
  eventStack: any;
  chartStack: any;
  edit: boolean;
  lock: boolean;
  utc: string;
  timeZones: any;
  timezone: string;
  timezoneoffset: number;
  period: string;
  currTimeLabel: String;
  transcation: Transaction;
  users: User[];
  activeTimeLabel: String;
  currentDatabaseService: KeyLabel;
  currentDBType: KeyLabel;
  showQueryForm: boolean;
  showQueryTable: boolean;
  showRunQueryTable: Boolean;
  queryTableData: any;
  addWidgetData: AddWidgetData;
  compareDurationRow: Duration;
  isCompareOptionsSelected: Boolean;
  isCompareCustom: Boolean;
  disablePrevious: Boolean;
  capPermInfo: CapabilityPermission[];
  roleFormData: RoleFormData;
  customPermData: CustomPermData;
  groupRoleFormData: GroupRoleFormData;
  roleTenant: LabelKeyType;
  userFormData: UserFormData;
  rolesAndGroupRolesFieldData: RolesAndGroupRolesFieldData;
  reloadTable: boolean;
  customRange: any[] | null;
}
interface RexSearchSelectItem {
  name: VueI18n.TranslateResult | string;
  id: string;
}
export interface QueryFormInfo {
  metricName: string;
  dbType: String;
  serviceId: String;
  serviceName: string;
  query: string;
}
export interface AddDashboardInfo {
  widgetName: string;
  dashboardName: string;
  dashboard: RexSearchSelectItem;
  widgetType: string;
}

interface WidgetFormData {
  isDashNameValid: boolean;
  isDashboardValid: boolean;
  isCreateOrUpdate: boolean;
  isQueryExecuted: boolean;
  isNewDashboard: Boolean;
}
export interface AddWidgetData {
  addDashboardInfo: AddDashboardInfo;
  widgetFormData: WidgetFormData;
  queryFormInfo: QueryFormInfo;
}
const initialState: State = {
  durationRow: getDurationRow(),
  durationLicenseRow: getDurationLicenseRow(),
  durationUtc: getDurationUtc(),
  eventStack: [],
  chartStack: [],
  edit: false,
  lock: true,
  utc: getEnv('VUE_APP_UTC_TIME') || '0',
  period: '15 min',
  timeZones: [],
  timezone: '',
  timezoneoffset: getTimeZoneOff(),
  currTimeLabel: timeLabels.fiveMins,
  transcation: transactionInit,
  users: [],
  currentDatabaseService: { key: '', label: '' },
  currentDBType: { key: '', label: '' },
  showQueryForm: false,
  showQueryTable: false,
  showRunQueryTable: false,
  queryTableData: {
    total: 0,
    records: [],
  },
  addWidgetData: _.cloneDeep(addWidgetDefulatData),
  activeTimeLabel: timeLabels.fiveMins,
  compareDurationRow: getDurationRow(),
  isCompareOptionsSelected: false,
  isCompareCustom: false,
  disablePrevious: false,
  capPermInfo: [],
  roleFormData: { roleName: '', resourceGroups: [] },
  customPermData: {
    currCapability: '',
    resources: [],
    showCusView: false,
    permissions: [],
  },
  groupRoleFormData: { groupRoleName: '', isDefault: false, tenantRoles: [] },
  roleTenant: { label: '', key: '' },
  userFormData: { firstName: '', lastName: '', emailId: '' },
  rolesAndGroupRolesFieldData: {
    groupRoles: [],
    tenantRoles: [],
    isGroupRole: true,
  },
  reloadTable: false,
  customRange: null,
};
export default {
  namespaced: true,
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations,
  // actions,
  // mutations
};
